// Firebase configuration loaded from environment variables
// Firebase client config is safe to expose (it's meant to be public)

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDfFbiISj8dfn02Qg2r0pwYJMUyaIGOvlY",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "aigen-26e51.firebaseapp.com",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://aigen-26e51-default-rtdb.firebaseio.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "aigen-26e51",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "aigen-26e51.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "671733327538",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:671733327538:web:7ab399fd413789225c8bab",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-HBX5Z43NSP"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const firebaseAuth = getAuth(app);